export default __webpack_public_path__ + "static/media/dreamscape_low.29b76ae5.mp4";